import { Component, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonModal } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { format, parseISO } from 'date-fns';
// import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
import type { IonInput } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-input-general',
  templateUrl: './input-general.component.html',
  styleUrls: ['./input-general.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputGeneralComponent),
      multi: true
    }
  ]
})
export class InputGeneralComponent implements OnInit {
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() formControlName: any;

  @Input() label: any =  '';
  @Input() value: any = '';
  @Input() placeholder: any = '';
  @Input() tipe: any = 'text';
  @Input() onlyNumber = false;
  @Input() onlyDecimal = false;
  @Input() alphaOnly = false;
  @Input() required = false;
  @Input() disabel = false;
  @Input() modeInput: any = 'general';
  @Input() ngModel: any = '';

  @Input() icon: any =  '';
  @Input() positionIcon: any =  '';
  @Input() name: any = '';
  @Input() interface: any = '';
  @Input() imageUrl?: string = '';

  @Input() paramSelect: any = '';
  @Input() idDate: any =  'axx';
  @Input() maxx: any =  '';
  @Input() minn: any =  '';
  @Input() iconrequired = false;
  
  // OUTPUT
  @Output() ngModelChange = new EventEmitter<string>();

  //PHOTO
  base64: string = '';
  fileSelected?: Blob;
  // imageUrl?: string;
  files;
  fotoktp: string = '';

  // DROPDOWN
  tit: any;
  tt: any;
  load: boolean = false;


  //PASWORD
  alertText: boolean = false;
  public isDisabled = false;
  passwordToggleIcon = 'eye-off-outline';
  showPassword = false;

  //DATE
  @ViewChild(IonModal) modal: IonModal;

  //GENDER
  selct: any = 'P';

  //warganegara
  selctW: any = 'WNI';

  selctP: any = 'Y';

  // CAMERA
  sp: any;
  filename: any;
  img: File;

  @ViewChild('ionInputEl', { static: true }) ionInputEl!: IonInput;

  inputModel = '';

  usertoken: any = '';
  loadktpPemohon: boolean = false;
  photoKtpPemohonx: any;

  progressInfosNpwp: any[] = [];
  messageNpwp: string[] = [];
  imageSrc1Npwp: string = '';
  selectedFilesNpwp?: FileList;
  selectedFileNamesNpwp: string[] = [];
  imageInfosNpwp?: Observable<any>;
  prev1Npwp: any = '';
  imgNpwp: File;

  maxData: any = (new Date()).getFullYear() + 80;
  maxData10: any = (new Date()).getFullYear() + 10;

  // valuex: any = '';
  dateStart: any = '';
  dateEnd: any = '';

  @Input() reset: boolean = false;
  @Input() valuex: string;
  @Input() resetInput: boolean;
  @Input() branch_id: any = '';
  @Input() userType: any = '';
userData: any = {};


  constructor(
    public api: ApiService,
    public util: UtilService,
    // public camera: Camera,
    public dom: DomSanitizer,

  ) {
    this.usertoken = localStorage.getItem('usertoken') || 'null';
    try {
      this.userData = JSON.parse(localStorage.getItem('user'))
    } catch (error) {
      console.log(error)
    }
    console.log('userData',this.userData)
  }

  onInput(ev) {
    const value = ev.target!.value;
    // const filteredValue = value.replace(/[^a-zA-Z0-9]+/g, '');
    // this.ionInputEl.value = this.value = filteredValue;
    if(value !== new RegExp(/[^a-zA-Z0-9]+/g)){
      return false
    }
    // this.changed(filteredValue);
    //   this.ngModelChange.emit(filteredValue);
    
  }

  limitText(event,max){
    const value = event.target.value;
    console.log('value',value);
    console.log('max',max)
    if (value.length > max) {
      value.substring(0, 16);
    }
  }
  
  get formField(): FormControl {
    return this.formGroup.get(this.formControlName) as FormControl;
  }
  
  ngOnInit() {
    // console.log('modeInput',this.modeInput)
    if(this.modeInput == 'gender'){
      this.selct = this.placeholder;
      this.pilih(this.placeholder)
      this.changed(this.selct);
      this.ngModelChange.emit(this.selct);
    }else if(this.modeInput == 'warganegara'){
      this.selctW = this.placeholder;
      this.pilihW(this.placeholder)
      this.changed(this.selctW);
      this.ngModelChange.emit(this.selctW);
    }else if(this.modeInput == 'memilikipasangan'){
      this.selctP = this.placeholder;
      this.pilihP(this.placeholder)
      this.changed(this.selctP);
      this.ngModelChange.emit(this.selctP);
    }

    
    
    if(this.tipe == 'cabang'){
      this.getComboBox('data/master/client-branch');
    }else if(this.tipe == 'grup'){
      this.getComboBox('data/master/group-menu');
    }else if(this.tipe == 'usertype'){
      this.getComboBox('data/master/user-client-type');
    }else if(this.tipe == 'bank'){
      this.getComboBox('data/master/bank');
    }else if(this.tipe == 'tenor'){
      this.getComboBox('data/master/tenor');
    }else if(this.tipe == 'agunan'){
      this.getComboBox('data/master/unit-agunan');
    }else if(this.tipe == 'plafon'){
      this.getComboBox('data/master/plafon');
    }else if(this.tipe == 'kolektor'){
      this.getComboBox('data/master/kolektor');
    }else if(this.tipe == 'htelat'){
      this.getComboBox('data/master/telat');
    }else if(this.tipe == 'surveyor'){
      this.getComboBox('data/master/surveyor');
    }else if(this.tipe == 'users'){
      this.getComboBox('backoffice/master/users?branch_id='+this.userData?.branch_id+'&user_type='+this.userType+'&client_id='+this.userData?.client_id);
    }else if(this.tipe == 'kelompok'){
      this.getComboBox('data/master/kelompok');
    }else if(this.tipe == 'pre_credit_status'){
      this.getComboBox('data/master/pre-credit-status');
    }else if (this.tipe == 'ao'){
      this.getComboBox('backoffice/master/ao?branch_id='+this.userData?.branch_id+'&user_type=AO&client_id='+this.userData?.client_id);
    }else if (this.tipe == 'users-app-sales'){
      this.getComboBox('data/master/users-app-sales/'+this.userData?.branch_id);
    }else if (this.tipe == 'user-status') {
      this.getComboBox('data/user-app-status');
    }
   }

   ngOnChanges(changes: SimpleChanges) {
    if (changes.resetInput && changes.resetInput.currentValue) {
      this.valuex = '';
    }
    if (changes.branch_id && this.tipe === 'users') {
      // Cek jika branch_id berubah
      if (changes.branch_id.currentValue !== changes.branch_id.previousValue) {
        this.value = ''; // Reset value pada dropdown user
        this.ngModelChange.emit(''); // Kirim perubahan ke parent component
        if (this.branch_id) { // Hanya panggil API jika branch_id ada isinya
          this.getComboBox('backoffice/master/users?branch_id='+this.branch_id+'&user_type='+this.userType+'&client_id='+this.userData?.client_id);
        } else {
          this.tt = []; // Kosongkan pilihan jika branch_id di-reset
        }
      }
    }
  }

  resetInputValue() {
    this.resetInput = !this.resetInput; // Toggle flag untuk memicu reset
  }

   onSelectionChange($event) {
    var selectedValue = $event.target.value;
    console.log('selectedValue',selectedValue)
    this.ngModelChange.emit(selectedValue);
  }

  changed = (value: any): void => { }
  touched = (): void => { console.log('halo touch'); };

  doInput(event: any) {
    // console.log(event)
    let value = event.target.value;
    if (this.onlyDecimal) {
      value = this.util.normalizeDecimalInput(value);
      if (event.target) {
        event.target.value = value;
      }
      this.value = value;
    }
    this.changed(value);
    this.ngModelChange.emit(value);
  }

  updateDateValue(value: any) {
    const formattedValue = this.formatDate(value);
    this.value = formattedValue;
    this.changed(formattedValue);
    this.ngModelChange.emit(formattedValue);
  }

  registerOnChange(fn: any): void {
    this.changed = fn;
  }

  registerOnTouched(fn: any): void {
    this.touched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(value: any) {
    this.value = value;
  }

  customCounterFormatter(inputLength: number, maxLength: number) {
    return `${maxLength - inputLength} Karakter Tersisa`;
  }

  validasi(event: any) {
    const value = event.target.value;
    if (this.required == true) {
      if (value == '') {
        this.alertText = true;
      } else {
        this.alertText = false;
      }
    }
  }

  isDecimalKey = (event, element) => {
    event.target.setCustomValidity('');
    const patt = /^\d+\.{0,1}\d{0,2}$/;
    let value = event.target.value;
    if (!patt.test(value)) {
      event.target.reportValidity();
      element.setAttribute("maxlength", value.length);
    }
    else {
      element.removeAttribute("maxlength")
    }
    if (value.length === 0) {
      element.removeAttribute("maxlength");
    }
  }
  
  onlyNum(event) {
    const key = event?.key;
    if (key === 'Backspace' || key === 'Delete' || key === 'Tab' || key === 'ArrowLeft' || key === 'ArrowRight') {
      return true;
    }
    return /^[0-9]$/.test(key);
  }

  onlyDecimalKey(event) {
    const key = event?.key;
    if (key === 'Backspace' || key === 'Delete' || key === 'Tab' || key === 'ArrowLeft' || key === 'ArrowRight') {
      return true;
    }
    if (key === '.' || key === ',') {
      const current = event?.target?.value ?? '';
      return !String(current).includes('.');
    }
    return /^[0-9]$/.test(key);
  }

  alphaOnlyx(event) {
    console.log('event',event)
    const xx = event.target.value;
    var value = String.fromCharCode(xx);
    console.log('value',value)
    var pattern = new RegExp(/[A-Za-z.,' ']/i);
    // return pattern.test(xx);
    var aa = pattern.test(xx)
    console.log('aa',aa)
    this.changed(aa);
    this.ngModelChange.emit(value);
  }

  alphaNumNoSpaceAndSymbol(event) {
    var value = String.fromCharCode(event.which);
    var pattern = new RegExp(/[A-Za-z0-9]/i);
    return pattern.test(value);
  }

  alphaNumNoSpace(event) {
    var value = String.fromCharCode(event.which);
    var pattern = new RegExp(/^\S*$/);
    return pattern.test(value);
  }

  special_char(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    if (this.passwordToggleIcon == 'eye-off-outline') {
      this.passwordToggleIcon = 'eye-outline';
    } else {
      this.passwordToggleIcon = 'eye-off-outline';
    }
    console.log('EYE PASSWORD');
  }

  photoKtpp(event: any) {
    this.files = event.target.files;
    if (this.files && this.files[0]) {
      this.fileSelected = event.target.files[0];
      const numberOfFiles = this.files.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageUrl = e.target.result;
          this.convertKtp();
        };
        reader.readAsDataURL(this.files[i]);
      }
    }
  }

  convertKtp(): void {
    this.loadktpPemohon = false;
    let reader = new FileReader();
    reader.readAsDataURL(this.fileSelected as Blob);
    reader.onloadend = () => {
      console.log(reader.result);
      this.fotoktp = reader.result as string;
      this.changed(this.fotoktp);
      this.ngModelChange.emit(this.fotoktp);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  photoFile(event: any): void {
    // this.messageNpwp = [];
    // this.progressInfosNpwp = [];
    // this.selectedFileNamesNpwp = [];
    // this.selectedFilesNpwp = event.target.files;
    // if (this.selectedFilesNpwp && this.selectedFilesNpwp[0]) {
    //   this.imgNpwp = event.target.files[0];
    //   this.changed(this.imgNpwp);
    //   this.ngModelChange.emit(this.imgNpwp);
    //   const numberOfFiles = this.selectedFilesNpwp.length;
    //   for (let i = 0; i < numberOfFiles; i++) {
    //     const reader = new FileReader();
    //     reader.onload = (e: any) => {
    //       this.prev1Npwp = e.target.result;
    //     };
    //     reader.readAsDataURL(this.selectedFilesNpwp[i]);
    //     this.selectedFileNamesNpwp.push(this.selectedFilesNpwp[i].name);
    //   }
    // }
  }

  dismiss() {
    this.modal.dismiss();
  }

  formatDateStart(value: any) {
    console.log(value)
    this.dateStart= format(parseISO(value), 'yyyy-MM-dd');
    this.valuex = this.dateStart+' - '+this.dateEnd;
    console.log('valuex',this.valuex)
    console.log('dateStart',this.dateStart)
  }

  formatDateEnd(start: any, end: any) {
    console.log(start);
    console.log(end)
    this.dateStart= format(parseISO(start), 'yyyy-MM-dd');

    this.dateEnd = format(parseISO(end), 'yyyy-MM-dd');
    this.valuex = this.dateStart+' - '+this.dateEnd;
    console.log('valuex',this.valuex)
    console.log('dateEnd',this.dateEnd)
  }

  onSelectionChangeDate($event){
    var selectedValue = $event.target.value;
    console.log('selectedValue',selectedValue)
    this.valuex = this.dateStart+' - '+this.dateEnd;
    console.log('valuex',this.valuex)
    this.ngModelChange.emit(selectedValue);
    
   }

  formatDate(value: any) {
    console.log(value)
    return format(parseISO(value), 'yyyy-MM-dd');
  }

  formatTime(value: any) {
    console.log(value)
    return format(parseISO(value), 'HH:mm');
  }

  pilih(p){
    console.log(p);
    if(this.selct == ''){
      this.selct = p;
    } else if (this.selct == p){
      // this.selct = '';
    } else {
      this.selct = p;
    }
    this.changed(this.selct);
    this.ngModelChange.emit(this.selct);
    console.log('selct', this.selct);
  }

  pilihW(p){
    console.log(p);
    if(this.selctW == ''){
      this.selctW = p;
    } else if (this.selctW == p){
      // this.selct = '';
    } else {
      this.selctW = p;
    }
    this.changed(this.selctW);
    this.ngModelChange.emit(this.selctW);
    console.log('selctW', this.selctW);
  }

  pilihP(p){
    console.log(p);
    if(this.selctP == ''){
      this.selctP = p;
    } else if (this.selctP == p){
      // this.selct = '';
    } else {
      this.selctP = p;
    }
    this.changed(this.selctP);
    this.ngModelChange.emit(this.selctP);
    console.log('selctP', this.selctP);
  }


  getComboBox(url: any){
    this.load = true;
    this.api.get(url)
      .subscribe((data) => {
        this.tit = data;
        if (this.tit.error == 0) {
          this.load = false;
            const rawOptions = this.tit.data || [];
            this.tt = (Array.isArray(rawOptions) ? rawOptions : []).map((item: any) => ({
              ...item,
              id: item?.id ?? item?._id ?? item?.value ?? '',
              text: item?.text ?? item?.name ?? item?.label ?? item?.id ?? item?._id ?? '',
              name: item?.name ?? item?.text ?? item?.label ?? item?.id ?? item?._id ?? '',
            }));
        } else {
          this.load = false;
          this.util.showToast(this.tit.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  captureImage(){
    // const options: CameraOptions = {
    //   destinationType: this.camera.DestinationType.DATA_URL,
    //   encodingType: this.camera.EncodingType.JPEG,
    //   mediaType: this.camera.MediaType.PICTURE,
    //   sourceType: this.camera.PictureSourceType.CAMERA,
    //   allowEdit: false,
    //   correctOrientation: true,
    //   saveToPhotoAlbum:false,
    //   quality: 100,
    //   targetWidth: 1000,
    //   targetHeight: 700
    // }
    // this.camera.getPicture(options).then((imageData) => {
    //   this.sp = 'data:image/jpeg;base64,' + imageData;
    //   this.filename = imageData;
    //   this.img = imageData;
    //   this.imageUrl = this.sp;
    //   console.log('filename',this.filename)
    //   this.changed(this.filename);
    //   this.ngModelChange.emit(this.filename);
    //   // this.uploadImageCam()
    // }, (err) => {
    //   console.log('Gagal mengambil foto...', err);
    //   this.util.showToast('Gagal mengambil foto'+err, 'danger', 'bottom');
    // });
  }

  async transform(src: string) {
    let fetchOptions = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + this.usertoken,
      },
    };
    var that = this;
    fetch(
      src,
      fetchOptions
    )
      .then((response) => response.blob())
      .then((imageBlob) => {
        const reader = new FileReader();
        this.loadktpPemohon = false;
        reader.onloadend = () => {
          that.photoKtpPemohonx = reader.result;
          console.log('photoKtpPemohonx',that.photoKtpPemohonx);
          that.imageUrl = this.dom.bypassSecurityTrustUrl(that.photoKtpPemohonx) as string;
          console.log('url im', that.imageUrl)
        };
        reader.readAsDataURL(imageBlob);
      });
  }

}
